import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { standardCommand } from '../../../core/model/command';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { LettingFeatureAdmin } from '../../model/letting-feature-admin';
import { LettingFeatureFormCommandHandlerResolver } from '../../service/command/letting-feature-form-command-handler-resolver.service';
import { LettingFeatureAdminService } from '../../service/data/letting-feature-admin.service';

@Component({
  selector: 'app-letting-feature-form',
  templateUrl: './letting-feature-form.component.html',
  providers: [DeleteFormCommandHandler, LettingFeatureFormCommandHandlerResolver, { provide: DataService, useExisting: LettingFeatureAdminService }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LettingFeatureFormComponent extends FormComponentBase<LettingFeatureAdmin> {
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly formControlFactory: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: LettingFeatureFormCommandHandlerResolver,
    service: LettingFeatureAdminService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, commandDispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  protected createModel(): LettingFeatureAdmin {
    return new LettingFeatureAdmin();
  }

  protected getFormGroup(): FormGroup {
    return this.formBuilder.group({
      phrase: this.formControlFactory.createWithOptions('LETTING_FEATURE.CAPTION', this.dataContext.phrase, { required: true }),
      isActive: this.formControlFactory.create('LETTING_FEATURE.IS_ACTIVE', this.dataContext.isActive),
    });
  }
}
